import { appConfig } from './app.js';
import { regions } from './regions.js';
export const standardFlags = [
    {
        feature: 'maintenance-mode',
        description: 'Shows the maintenance screen (use during ERP pricing syncs or upgrades).',
        type: 'kill-switch',
    },
    {
        feature: 'coming-soon',
        description: 'Pre-launch holding page instead of the planner.',
        type: 'kill-switch',
    },
    {
        feature: 'show-retail-checkout',
        description: 'Shows the Bunnings retail checkout button.',
        type: 'kill-switch',
        requiresFeature: 'bunnings',
    },
    {
        feature: 'show-trade-checkout',
        description: 'Shows the trade checkout button.',
        type: 'kill-switch',
        requiresFeature: 'bunnings',
    },
];
/**
 * Flag key for a feature: `<feature>-<region>` in prod, `<feature>-<env>-<region>`
 * elsewhere — the house-signs scheme, kept so existing prod flag keys stay valid.
 */
export function flagKey(feature, env, regionCode) {
    return env === 'prod' ? `${feature}-${regionCode}` : `${feature}-${env}-${regionCode}`;
}
/**
 * State applied only when a flag is first created. Existing flags are left
 * alone. Door Planner launch defaults: retail and trade checkout on in dev
 * and uat, coming-soon on in prod, everything else off (including prod
 * checkouts until Bunnings ranging is confirmed).
 */
export function flagInitiallyActive(feature, env) {
    if (feature === 'coming-soon') {
        return env === 'prod';
    }
    if (feature === 'show-retail-checkout' || feature === 'show-trade-checkout') {
        return env !== 'prod';
    }
    return false;
}
/** Every standard flag expanded across all environments and configured regions. */
export function expandStandardFlags() {
    const environments = ['dev', 'uat', 'prod'];
    const flags = [];
    for (const definition of standardFlags) {
        if (definition.requiresFeature && !appConfig.features[definition.requiresFeature]) {
            continue;
        }
        for (const env of environments) {
            for (const region of regions) {
                flags.push({
                    key: flagKey(definition.feature, env, region.code),
                    feature: definition.feature,
                    environment: env,
                    region: region.code,
                    description: `${definition.description} [${env}/${region.code}]`,
                    tags: [definition.type, env],
                });
            }
        }
    }
    return flags;
}
//# sourceMappingURL=posthog.js.map